import {
  loopbackGet,
  loopbackPost,
} from '..';

import { Invoice } from '../../redux/types';

export const createOrUpdateInvoice = (
  enrollmentId: number, clearingType: string, billingId?: number,
): Promise<any> => {
  const billingIdQueryString = billingId ? `&billingId=${billingId}` : '';
  return loopbackGet(
    `Enrollments/${enrollmentId}/createOrUpdateInvoice?clearingType=${clearingType}${billingIdQueryString}`,
  );
};

export const authorizePayment = (
  trialId: number, invoiceId: number, clearingType: string,
): Promise<any> => loopbackPost(
  `trials/${trialId}/authorizePaymentViaPayone?invoiceId=${invoiceId}&clearingType=${clearingType}`,
);

export const setInvoiceOrderNumber = (
  invoiceId: number, orderNumber: string,
): Promise<Invoice> => loopbackPost(
  `Invoices/${invoiceId}/setOrderNumber`, { orderNumber },
);

/**
 * get the filename of the pdf if it already exists on the server's file system,
 * otherwise the api will create the file on the server and will return the file name
 *
 * @param invoiceId number
 * @returns file name of the invoice pdf on the server filesystem
 */
export const getInvoicePdf = (invoiceId: number): Promise<string> => {
  const uri = `Invoices/${invoiceId}/downloadInvoicePdf`;
  return loopbackGet(uri);
};

export const getEInvoice = (enrollmentId: number): Promise<string> => {
  const uri = `Invoices/${enrollmentId}/downloadEInvoice`;
  return loopbackGet(uri);
};

export const confirmPayment = (paymentToken: any): Promise<any> => loopbackPost(
  `payments/${paymentToken.paymentid}/bookPayment`, paymentToken,
);
